import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { IIAP, IShop } from 'skygame-data';
import { DataService } from '@app/services/data.service';
import { IAPService } from '@app/services/iap.service';
import { IapCardComponent } from '@app/components/shared/shared-widgets';
import { SectionQuickActionsComponent } from '@app/components/shared/quick-actions/section-quick-actions.component';

@Component({
  selector: 'app-shop-office',
  templateUrl: './shop-office.component.html',
  styleUrl: './shop-office.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, IapCardComponent, SectionQuickActionsComponent]
})
export class ShopOfficeComponent {
  private readonly _iapService = inject(IAPService);

  readonly iapShops: ReadonlyArray<IShop>;

  readonly highlightIap = signal<string | undefined>(undefined);

  constructor(dataService: DataService, route: ActivatedRoute) {
    const shops = dataService.shopConfig.items.filter(s => s.permanent === 'office');
    this.iapShops = shops.filter(s => s.iaps?.length);

    route.queryParamMap.subscribe(p => this.onQueryChanged(p));
  }

  private onQueryChanged(p: ParamMap): void {
    this.highlightIap.set(p.get('highlightIap') || undefined);
  }

  togglePurchased(iap: IIAP): void {
    this._iapService.togglePurchased(iap);
  }

  toggleGifted(iap: IIAP): void {
    this._iapService.toggleGifted(iap);
  }
}
